import {
	COMMAND_BAR_ICON,
	COMMAND_BAR_PLACEMENT_ID,
	TOOL_PREFERENCES_COMMAND_BAR_FLAG,
	TOOL_PREFERENCES_URL_FLAG,
	TOOL_PREFERENCES_SLACK_FLAG,
	URL_ICON,
	URL_PLACEMENT_ID,
	SLACK_PLACEMENT_ID,
	/**
	HOME_MENU_PLACEMENT_ID,
	MULTI_PLACEMENT_ID,
	*/
} from '@/utils/workflow-tool-service.const';
import ToolCommandBarPlacementData from './ToolPlacementDataComponents/ToolCommandBarPlacementData';
import ToolURLPlacementData from './ToolPlacementDataComponents/ToolURLPlacementData';
import ToolSlackPlacementData from './ToolPlacementDataComponents/ToolSlackPlacementData';
import { FEATURE_FLAGS } from '@/utils/feature-toggle-service';
export const TOOL_PLACEMENTS = {
	// [MULTI_PLACEMENT_ID]: {
	// 	id: MULTI_PLACEMENT_ID,
	// 	title: 'Multi-placement (default)',
	// 	headerTitle: 'multiple placements',
	// 	description: 'Use your tool from the home menu, command bar and a URL',
	// 	toolIcons: [HOME_MENU_ICON, COMMAND_BAR_ICON, URL_ICON],
	// },
	// [HOME_MENU_PLACEMENT_ID]: {
	// 	id: HOME_MENU_PLACEMENT_ID,
	// 	title: 'Home menu',
	// 	toolIcon: HOME_MENU_ICON,
	// },
	[COMMAND_BAR_PLACEMENT_ID]: {
		id: COMMAND_BAR_PLACEMENT_ID,
		title: 'Command bar (default)',
		headerTitle: 'Command bar',
		description: 'Also appears in home menu',
		toolIcon: COMMAND_BAR_ICON,
		extensionNeeded: true,
		style: { height: '100px' },
		descriptionInNewLine: true,
		dataComponent: ToolCommandBarPlacementData,
		toolPlacementFlag: TOOL_PREFERENCES_COMMAND_BAR_FLAG,
	},
	[URL_PLACEMENT_ID]: {
		id: URL_PLACEMENT_ID,
		title: 'URL',
		headerTitle: 'URL (with parameters)',
		description: 'with parameters',
		toolIcon: URL_ICON,
		dataComponent: ToolURLPlacementData,
		toolPlacementFlag: TOOL_PREFERENCES_URL_FLAG,
	},
	[SLACK_PLACEMENT_ID]: {
		id: SLACK_PLACEMENT_ID,
		title: 'Slack',
		headerTitle: 'Slack',
		description: 'Slash Command bar',
		toolIcon: URL_ICON,
		dataComponent: ToolSlackPlacementData,
		toolPlacementFlag: TOOL_PREFERENCES_SLACK_FLAG,
		conditionalFlag: FEATURE_FLAGS.SLACK_COMMAND_ENABLED,
	},
};
